import { render, staticRenderFns } from "./staffsalaries.vue?vue&type=template&id=f750e46c"
import script from "./staffsalaries.vue?vue&type=script&lang=js"
export * from "./staffsalaries.vue?vue&type=script&lang=js"
import style0 from "./staffsalaries.vue?vue&type=style&index=0&id=f750e46c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports